import { createContext } from 'react'
import ItemsManipulator from "./../services/ItemsManipulator"

export const BrowserContext = createContext({
    handleCurrentPath : () => {},
    handleCarouselActiveFileName : () => {},
    handleRenameItemName : () => {},
    handleClipboard : () => {},
    itemsManipulator : new ItemsManipulator()
})